// это посто сама по себе аввтарка школы
import React from 'react';

const ShopAvatar = (props) => {
    const {size, shopId, style} = props;
    const avatarUrl = 'https://capoeirasport.com/graphics/logo_shop/' + shopId + '.png';
    return <img style = {{width: size, height: size, ...style}} src = {avatarUrl}/>
}

export default ShopAvatar;